<template>
  <div @input.stop="handleInput">
    <div
      :class="[
        isSubmiting ? 'spinner' : '',
        fixedSize ? 'fixed-size' : '',
        classes
      ]"
    >
      <div
        :class="[
          error || backendError ? 'error' : '',
          isSubmiting ? 'opacity-25' : '',
          classes
        ]"
      >
        <slot />
      </div>
    </div>

    <div
      v-if="error"
      :class="errorClass"
      class="error-message"
    >
      {{ error }}
    </div>
    <div
      v-else-if="backendError"
      :class="errorClass"
      class="error-message"
    >
      {{ backendError }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

// Props
const props = defineProps({
  error: {
    type: String,
    default: '',
  },
  field: {
    type: [String, Number],
    default: '',
  },
  fixedSize: {
    type: Boolean,
    default: false,
  },
  errorClass: {
    type: String,
    default: '',
  },
  classes: {
    type: String,
    default: '',
  },
})

const { submittings, backendErrors, removeBackendError } = useStoreFields()

// Computed
const isSubmiting = computed(() => {
  return submittings.value[props.field]
})

const backendError = computed(() => {
  return backendErrors.value[props.field]
})

// Methods
const handleInput = () => {
  removeBackendError(props.field)
}
</script>

<style lang="sass" scoped>
  .error-message
    @apply my-2
    font-size: 13px
    color: #FA3434

  .spinner
    background: url('/dots.svg')
    pointer-events: none
    @apply h-full bg-center bg-no-repeat
    &.fixed-size
      background-size: 60px

  :deep(.error)
    .uppy-wrapper
      box-shadow: 0 0 0 4px #F56565 !important
    .uppy-Dashboard
      @apply rounded-[12px] bg-red-100
    input
      @apply bg-red-100 border-4 border-red-500
    textarea
      @apply bg-red-100 border-4 border-red-500
    .vue-tel-input
      @apply bg-red-100 border-4 border-red-500
      .vti__input
        @apply bg-red-100
    #autosuggest
      input
        @apply bg-red-100 border-4 border-red-500 rounded-[12px]
    .multiselect
      @apply bg-red-100 rounded-[12px]
      .multiselect__tags
        @apply bg-red-100 rounded-[12px] border-4 border-red-500
        .multiselect__single
          @apply bg-red-100
</style>
